import React, { useState } from 'react';
import { Card, Form, Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const ChangePasswordPage = () => {
  const { changePassword, mustChangePassword, logout } = useAuth();
  const navigate = useNavigate();
  const [current, setCurrent] = useState('');
  const [next, setNext] = useState('');
  const [confirm, setConfirm] = useState('');
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError('');
    if (next.length < 8) return setError('La nueva contraseña debe tener al menos 8 caracteres.');
    if (next !== confirm) return setError('La confirmación no coincide con la nueva contraseña.');
    setBusy(true);
    try {
      await changePassword(current, next);
      navigate('/dashboard');
    } catch (err) {
      setError(err.response?.data?.message || 'No se pudo cambiar la contraseña.');
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="container" style={{ maxWidth: 480, marginTop: 60 }}>
      <Card className="shadow-sm p-4">
        <h3 className="app-title" style={{ textAlign: 'left' }}>Cambiar contraseña</h3>
        {mustChangePassword && (
          <div className="alert alert-warning">
            Un administrador creó o restableció tu cuenta: elige tu propia contraseña para continuar.
          </div>
        )}
        {error && <div className="alert alert-danger">{error}</div>}
        <Form onSubmit={submit}>
          <Form.Group className="mb-3">
            <Form.Label>Contraseña actual</Form.Label>
            <Form.Control type="password" autoComplete="current-password" value={current} onChange={e => setCurrent(e.target.value)} />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Nueva contraseña <span className="text-muted small">(mínimo 8 caracteres)</span></Form.Label>
            <Form.Control type="password" autoComplete="new-password" value={next} onChange={e => setNext(e.target.value)} />
          </Form.Group>
          <Form.Group className="mb-4">
            <Form.Label>Confirmar nueva contraseña</Form.Label>
            <Form.Control type="password" autoComplete="new-password" value={confirm} onChange={e => setConfirm(e.target.value)} />
          </Form.Group>
          <div className="d-flex gap-2">
            <Button type="submit" disabled={busy || !current || !next || !confirm}>{busy ? 'Guardando...' : 'Guardar contraseña'}</Button>
            {mustChangePassword
              ? <Button variant="outline-secondary" onClick={logout}>Cerrar sesión</Button>
              : <Button variant="outline-secondary" onClick={() => navigate(-1)}>Cancelar</Button>}
          </div>
        </Form>
      </Card>
    </div>
  );
};

export default ChangePasswordPage;
